import { Routes } from '@angular/router';
import { AuthGuard, AccesoGuard } from './core/guards/auth.guard';
import { Acceso } from './core/models/danoral.models';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'desafiliar',
    loadComponent: () =>
      import('./features/desafiliar/desafiliar.component').then(m => m.DesafiliarComponent),
  },
  {
    path: 'votar',
    loadComponent: () =>
      import('./features/votar/votar.component').then(m => m.VotarComponent),
  },

  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then(m => m.LoginComponent),
  },

  {
    path: 'recuperar-codigo',
    loadComponent: () =>
      import('./features/auth/recuperar-codigo/recuperar-codigo.component').then(m => m.RecuperarCodigoComponent),
  },

  {
    path: 'app',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/shell/shell.component').then(m => m.ShellComponent),
    children: [
      { path: '', redirectTo: 'inicio', pathMatch: 'full' },
      {
        path: 'inicio',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'recibos',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.COD_CLIENTE] },
        loadComponent: () =>
          import('./features/recibos/recibos.component').then(m => m.RecibosComponent),
      },
      {
        path: 'pagos',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.COD_CLIENTE] },
        loadComponent: () =>
          import('./features/pagos/pagos.component').then(m => m.PagosComponent),
      },
      {
        path: 'gastos',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.COD_CLIENTE] },
        loadComponent: () =>
          import('./features/gastos/gastos.component').then(m => m.GastosComponent),
      },
      {
        path: 'formas-pago',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.COD_CLIENTE] },
        loadComponent: () =>
          import('./features/formas-pago/formas-pago.component').then(m => m.FormasPagoComponent),
      },
      {
        path: 'contacto',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.COD_CLIENTE] },
        loadComponent: () =>
          import('./features/contacto/contacto.component').then(m => m.ContactoComponent),
      },
      {
        path: 'cartelera',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.JUNTA_DIRECTIVA] },
        loadComponent: () =>
          import('./features/cartelera/cartelera.component').then(m => m.CarteleraComponent),
      },
      {
        path: 'admin/inicio',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.ANALISTA_CONTACTO, Acceso.GESTOR_COBRANZA, Acceso.EJECUTIVO, Acceso.GESTOR_DE_CONTENIDO] },
        loadComponent: () =>
          import('./features/admin/admin-inicio.component').then(m => m.AdminInicioComponent),
      },
      {
        path: 'admin/deuda-grafica',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO] },
        loadComponent: () =>
          import('./features/admin/deuda-grafica.component').then(m => m.DeudaGraficaComponent),
      },
      {
        path: 'admin/balance',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.EJECUTIVO] },
        loadComponent: () =>
          import('./features/admin/admin-balance/admin-balance.component').then(m => m.AdminBalanceComponent),
      },
      {
        path: 'admin/movimiento',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.EJECUTIVO] },
        loadComponent: () =>
          import('./features/admin/admin-movimiento/admin-movimiento.component').then(m => m.AdminMovimientoComponent),
      },
      {
        path: 'usuarios',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR] },
        loadComponent: () =>
          import('./features/usuarios/usuarios.component').then(m => m.UsuariosComponent),
      },
      {
        path: 'admin/usuarios',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR] },
        loadComponent: () =>
          import('./features/admin/admin-usuarios/admin-usuarios.component').then(m => m.AdminUsuariosComponent),
      },
      {
        path: 'admin/mi-cuenta',
        loadComponent: () =>
          import('./features/mi-cuenta/mi-cuenta.component').then(m => m.MiCuentaComponent),
      },
      // ── Reportes (solo Admin Total; el reporte de Interacción IA además
      // exige 100099 - la persona con ese rol debe tener TAMBIEN admin
      // asignado para poder entrar a esta sección) ────────────────────────
      {
        path: 'admin/reportes',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR] },
        loadComponent: () =>
          import('./features/admin/admin-reportes/admin-reportes.component').then(m => m.AdminReportesComponent),
      },
      {
        path: 'admin/reportes/api-logs',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR] },
        loadComponent: () =>
          import('./features/admin/admin-reportes/reporte-api-logs.component').then(m => m.ReporteApiLogsComponent),
      },
      {
        path: 'admin/reportes/salud-login',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR] },
        loadComponent: () =>
          import('./features/admin/admin-reportes/reporte-salud-login.component').then(m => m.ReporteSaludLoginComponent),
      },
      {
        path: 'admin/reportes/monitoreo-general',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR] },
        loadComponent: () =>
          import('./features/admin/admin-reportes/monitoreo-general.component').then(m => m.MonitoreoGeneralComponent),
      },
      {
        path: 'admin/reportes/notificaciones-pago',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR] },
        loadComponent: () =>
          import('./features/admin/admin-reportes/reporte-notificaciones-pago.component').then(m => m.ReporteNotificacionesPagoComponent),
      },
      {
        // EXCLUSIVO del rol SUPERVISOR_IA (100099) - a proposito NO incluye
        // ADMINISTRADOR, ni siquiera Admin Total debe verlo por defecto.
        path: 'admin/reportes/interaccion-ia',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.SUPERVISOR_IA] },
        loadComponent: () =>
          import('./features/admin/admin-reportes/reporte-interaccion-ia.component').then(m => m.ReporteInteraccionIaComponent),
      },
      {
        path: 'admin/usuarios-junta',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.EJECUTIVO] },
        loadComponent: () =>
          import('./features/admin/usuarios-junta/usuarios-junta.component').then(m => m.UsuariosJuntaComponent),
      },
      {
        path: 'admin/estado-cuenta',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.GESTOR_COBRANZA, Acceso.EJECUTIVO] },
        loadComponent: () =>
          import('./features/admin/admin-estado-cuenta/admin-estado-cuenta.component').then(m => m.AdminEstadoCuentaComponent),
      },
      {
        path: 'admin/noti-web',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.GESTOR_COBRANZA] },
        loadComponent: () =>
          import('./features/admin/noti-web/noti-web.component').then(m => m.NotiWebComponent),
      },
      {
        path: 'admin/reporte-gastos',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.EJECUTIVO] },
        loadComponent: () =>
          import('./features/admin/admin-reporte-gastos/admin-reporte-gastos.component').then(m => m.AdminReporteGastosComponent),
      },
      {
        path: 'admin/contacto',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.ANALISTA_CONTACTO, Acceso.GESTOR_COBRANZA] },
        loadComponent: () =>
          import('./features/admin/admin-contacto/admin-contacto.component').then(m => m.AdminContactoComponent),
      },
      {
        path: 'admin/cartelera',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.EJECUTIVO] },
        loadComponent: () =>
          import('./features/admin/cartelera-admin/cartelera-admin.component').then(m => m.CarteleraAdminComponent),
      },
      {
        path: 'admin/hub',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.GESTOR_DE_CONTENIDO] },
        loadComponent: () =>
          import('./features/admin/hub/hub-shell.component').then(m => m.HubShellComponent),
        children: [
          { path: '', redirectTo: 'bandeja', pathMatch: 'full' },
          {
            path: 'bandeja',
            loadComponent: () =>
              import('./features/admin/hub/hub-bandeja.component').then(m => m.HubBandejaComponent),
          },
          {
            path: 'nuevo',
            loadComponent: () =>
              import('./features/admin/hub/hub-selector-tipo.component').then(m => m.HubSelectorTipoComponent),
          },
          {
            path: 'editor/:id',
            loadComponent: () =>
              import('./features/admin/hub/hub-editor.component').then(m => m.HubEditorComponent),
          },
          {
            path: 'categorias',
            canActivate: [AccesoGuard],
            data: { titulo: 'Categorías', accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.GESTOR_DE_CONTENIDO] },
            loadComponent: () =>
              import('./features/admin/hub/hub-categorias.component').then(m => m.HubCategoriasComponent),
          },
          {
            path: 'comentarios',
            canActivate: [AccesoGuard],
            data: { titulo: 'Comentarios', accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.GESTOR_DE_CONTENIDO] },
            loadComponent: () =>
              import('./features/admin/hub/hub-moderacion.component').then(m => m.HubModeracionComponent),
          },
          {
            path: 'analitica',
            canActivate: [AccesoGuard],
            data: { titulo: 'Analítica', accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.GESTOR_DE_CONTENIDO] },
            loadComponent: () =>
              import('./features/admin/hub/hub-analitica.component').then(m => m.HubAnaliticaComponent),
          },
          {
            path: 'tipos-contenido',
            canActivate: [AccesoGuard],
            data: { titulo: 'Tipos de contenido', accesos: [Acceso.ADMINISTRADOR, Acceso.GESTOR_DE_CONTENIDO] },
            loadComponent: () =>
              import('./features/admin/hub/hub-tipos-contenido.component').then(m => m.HubTiposContenidoComponent),
          },
        ],
      },
      {
        path: 'admin/encuesta',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.EJECUTIVO] },
        loadComponent: () =>
          import('./features/admin/admin-encuesta/admin-encuesta.component').then(m => m.AdminEncuestaComponent),
      },
      {
        path: 'admin/leads',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.EJECUTIVO] },
        loadComponent: () =>
          import('./features/admin/admin-leads/admin-leads.component').then(m => m.AdminLeadsComponent),
      },
      {
        path: 'legal/casos',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.LEGAL] },
        loadComponent: () =>
          import('./features/legal/casos.component').then(m => m.CasosComponent),
      },
      {
        path: 'legal/entregas',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.LEGAL] },
        loadComponent: () =>
          import('./features/legal/entregas.component').then(m => m.EntregasComponent),
      },
      {
        path: 'legal/pagos',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.LEGAL] },
        loadComponent: () =>
          import('./features/legal/pagos-legales.component').then(m => m.PagosLegalesComponent),
      },
      {
        path: 'legal/recibos',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.LEGAL] },
        loadComponent: () =>
          import('./features/legal/recibos-legales.component').then(m => m.RecibosLegalesComponent),
      },
      {
        path: 'admin/entidades',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.ADMINISTRADOR, Acceso.ADMIN_RESTRINGIDO, Acceso.ANALISTA_CONTACTO] },
        loadComponent: () =>
          import('./features/entidades/entidades-explorer.component').then(m => m.EntidadesExplorerComponent),
      },
      {
        path: 'junta',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.COD_CLIENTE] },
        loadComponent: () =>
          import('./features/junta/junta.component').then(m => m.JuntaComponent),
      },
      {
        path: 'junta/estado-cuenta',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.COD_CLIENTE] },
        loadComponent: () =>
          import('./features/junta/junta-estado-cuenta.component').then(m => m.JuntaEstadoCuentaComponent),
      },
      {
        path: 'junta/reporte-gastos',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.COD_CLIENTE] },
        loadComponent: () =>
          import('./features/junta/junta-reporte-gastos.component').then(m => m.JuntaReporteGastosComponent),
      },
      {
        path: 'junta/balance',
        canActivate: [AccesoGuard],
        data: { accesos: [Acceso.COD_CLIENTE] },
        loadComponent: () =>
          import('./features/junta/junta-balance.component').then(m => m.JuntaBalanceComponent),
      },
    ],
  },

  {
    path: 'email-confirmado',
    loadComponent: () =>
      import('./features/confirmar-email/confirmar-email.component').then(m => m.ConfirmarEmailComponent),
  },

  { path: '**', redirectTo: 'login' },
];
